module.exports = __webpack_public_path__ + "img/feature-illustration-4.76ff36f.svg";